import {Layout} from "../../component/layout/Layout";
import {useEffect, useMemo, useRef, useState} from "react";
import {WorkflowProgress} from "../../component/layout/WorkflowProgress";
import {Button} from "../../component/form/Button";
import scancard from "../../img/scancard.png"
import example from "../../img/example-backside-card.jpg"
import {InputImageFancy} from "../../component/form/InputImageFancy";
import {InputText} from "../../component/form/InputText";
import {emptyGuestOrderItem, uploadImage} from "./GuestRequest";
import {post} from "../../js/api";
import {orderType} from "../../js/constants";
import {empty as emptyAddress} from "../../component/form/AddressInput";
import {showMessage} from "../../js/main";
import {SignOrder} from "../../component/SignOrder";
import {useHistory, useLocation} from "react-router";
import {useChangeEffect} from "../../js/util";

export const GuestRequestV2 = ({}) => {

    const history = useHistory();
    const location = useLocation();

    const workflowSteps = useMemo(() => ["Start", "Anleitung", "Fotos", "Kontakt", "Bestätigung", "Abschluss"], []);
    const backButtonVisible = useMemo(() => ["Anleitung", "Fotos", "Kontakt"], []);;
    const forwardButtonVisible = useMemo(() => ["Start", "Anleitung", "Fotos", "Kontakt"], []);

    const uniqueRef = useRef(new Set());

    const [currentStep, setCurrentStep] = useState(workflowSteps[0]);
    const [submitting, setSubmitting] = useState(false);

    const [orderInfoTokenPair, setOrderInfoTokenPair] = useState();

    const [request, setRequest] = useState({...emptyGuestOrderItem, amount: 1});

    const [foto1, setFoto1] = useState();
    const [foto2, setFoto2] = useState();
    const [sicherungskarte, setSicherungskarte] = useState();

    const [email, setEmail] = useState();

    const [tan, setTan] = useState();


    const previousStep = () => {
        const step = workflowSteps[workflowSteps.indexOf(currentStep) - 1 ];
        history.push(`${location.pathname}#${step}`);
        setCurrentStep(step);
        window.scrollTo({top: 0, behavior: "instant"});
    }

    const nextStep = () => {
        const step = workflowSteps[workflowSteps.indexOf(currentStep) + 1 ];
        history.push(`${location.pathname}#${step}`);
        setCurrentStep(step);
        window.scrollTo({top: 0, behavior: "instant"});
    }

    useChangeEffect(() => {
        if(history.action == 'POP'){
            const requestedStep = history.location.hash.substring(1);
            // we only allow going back
            if(workflowSteps.indexOf(requestedStep) == -1){
                setCurrentStep(workflowSteps[0]);
            } else if(workflowSteps.indexOf(requestedStep) < workflowSteps.indexOf(currentStep)){
                setCurrentStep(requestedStep);
            }
        }
    }, [history.location]);

    const formSubmitted = () => {

        switch (currentStep){
            case "Fotos":{
                setSubmitting(true);
                let updated = {...request};
                uploadImage("Seite1", foto1).then(s3url => {
                    updated.frontImage = s3url;
                    uploadImage("Seite2", foto2).then(s3url => {
                        updated.backImage = s3url;
                        setRequest(updated);
                        setSubmitting(false);
                        nextStep();
                    })
                });
                return;
                break;
            }
            case "Kontakt":{
                let updated = {...request};
                setSubmitting(true);

                const createRequest = (updated) => {
                    post("/guestRequests/createNewOrderItem", updated).then(item => {
                        const orderReq = {
                            summary: "Fotobestellung Schlüssel für " + email,
                            shippingInfo: undefined,
                            billingAddress: {...emptyAddress, email: email},
                            paymentType: undefined,
                            type: orderType.request,
                            items: [item]
                        };
                        post("/public/orders", orderReq, true).then(o => {
                            showMessage("Anfrage gespeichert. Sie haben eine Mail mit dem Bestätigungscode erhalten.");
                            setOrderInfoTokenPair(o);
                            setRequest(updated);
                            setSubmitting(false);
                            nextStep();
                        });
                    });

                }

                if(sicherungskarte){
                    setSubmitting("true");

                    uploadImage("Sicherungskarte", sicherungskarte).then(s3url => {
                        updated.authorization = s3url;
                        createRequest(updated);
                    })
                }else{
                    createRequest(updated);
                    setSubmitting(false);
                }
                return;
                break;
            }
        }

        nextStep();
    }

    return <>
        <Layout username={null}>
            <form className="guest-request-v2" onSubmit={(e) => {
                e.preventDefault();
                formSubmitted();
            }}>

                <WorkflowProgress steps={workflowSteps} currentStep={currentStep}></WorkflowProgress>
                {currentStep == 'Start' && <>
                    <h1>Starten Sie mit der Scancard</h1>
                    <p>Damit wir Ihren Schlüssel präzise nachmachen können, benötigen wir ein Foto aufgenommen auf unserer
                        ScanCard. Diese sorgt für die korrekte Vermessung. <br/><br/>
                        Sollten Sie gerade keinen Drucker haben reicht auch ein Foto ohne ScanCard, es kann allerdings zu
                        Rückfragen durch unser Team kommen.</p>

                    <div className="scancard-img-container">
                        <a href="https://key-direct-production-bucket.s3.eu-central-1.amazonaws.com/public/Scancard.pdf" target="_blank">
                            <img className="scancard-img" src={scancard} />
                        </a>
                        <Button width={300} onClick={e => {
                            e.preventDefault()
                            window.open("https://key-direct-production-bucket.s3.eu-central-1.amazonaws.com/public/Scancard.pdf");
                        }
                        }>ScanCard herunterladen (PDF)</Button>
                    </div>

                    <h2>Preisliste</h2>
                    <p>Sie bekommen nach Abschluss ein individuelles Angebot mit dem Preis für Ihren Schlüssel. Bis dahin finden Sie <a href={"/price-list"} target={"_blank"}>hier eine Preisübersicht.</a></p>
                </>}
                {currentStep == 'Anleitung' && <>
                    <h1>So machen Sie die Fotos Ihres Schlüssels</h1>
                    <p>Legen Sie Ihren Schlüssel auf die gedruckte Scancard und fotografieren Sie ihn von beiden Seiten. So können wir ihn später präzise nachmachen.</p>
                    <div className="default">
                        <div className={"example-img-container"}>
                            <h2>So sollte Ihr Foto aussehen:</h2>
                            <img src={example} className="example-img"/>
                        </div>
                        <div>
                            <h2>Wichtige Hinweise</h2>
                            <ul>
                                <li>Sorgen Sie für eine gute Beleuchtung</li>
                                <li>Schlüssel vollständig sichtbar</li>
                                <li>Beide Seiten fotografieren</li>
                                <li>alle umgebenden Muster sichtbar</li>
                            </ul>
                        </div>
                    </div>
                </>}
                {currentStep == 'Fotos' && <>
                    <h1>Bilder des Schlüssels hochladen</h1>
                    <p>Tipp: Verwenden Sie die Scancard für beste Ergebnisse</p>

                    <div className="default">
                        <InputImageFancy required={true} label={"Bild der ersten Seite"} setter={setFoto1} maxMBSize="10" uniqueRef={uniqueRef}></InputImageFancy>
                        <InputImageFancy required={true} label={"Bild der zweiten Seite"} setter={setFoto2} maxMBSize="10" uniqueRef={uniqueRef}></InputImageFancy>
                    </div>
                    <div class={"zeichnung"}><p>Hinweis: Wir prüfen automatisch, ob eine Berechtigung erforderlich ist. Falls ja, melden wir uns.</p></div>
                </>}
                {currentStep == 'Kontakt' && <>
                    <h1>Ihre Kontaktdaten</h1>
                    <h2>Kontaktdaten</h2>
                    <div className="default">
                        <InputText required={true} label={"E-Mail"} value={email} setter={setEmail}></InputText>
                    </div>
                    <h2>Sicherungskarte oder Berechtigung (falls vorhanden)</h2>
                    <p>Nur bei bestimmten Schlüsseln notwendig - wir prüfen das automatisch. Wenn Sie unsicher sind, lassen Sie das Feld frei.</p>
                    <div className="default">
                        <InputImageFancy label="Sicherungskarte" setter={setSicherungskarte} maxMBSize={10} uniqueRef={uniqueRef}></InputImageFancy>
                    </div>
                    <div className="zeichnung">
                        <h2>Das ist keine Bestellung - nur eine Anfrage!</h2>
                        <p>Nach Prüfung erhalten Sie ein konkretes Angebot mit Preis, Versandkosten und Lieferzeit. <br/>
                        <strong>Unverbindlich & Kostenlos</strong><br/>
                        <strong>Einfach absenden - wir melden uns!</strong></p>
                    </div>
                </>}
                {currentStep == 'Abschluss' && <>
                    <h1>Vielen Dank - Ihre Anfrage ist eingegangen!</h1>
                    <p>
                        Ihre Anfrage wird geprüft. In Kürze erhalten Sie eine E-Mail mit folgenden Informationen:
                        <ul>
                            <li>Erfolgreiche Prüfung der Schlüsselbilder</li>
                            <li>Rückmeldung, ob zusätzliche Unterlagen oder eine Berechtigung erfolderlich sind</li>
                            <li>Konkretes Angebot mit Preis pro Schlüssel inkl. Versandkosten</li>
                            <li>Voraussichtliche Lieferzeit</li>
                        </ul>
                    </p>
                    <h2>Informationen zur Bezahlung und zum Ablauf</h2>
                    <p>Wir starten die Produktion erst nach Bestätigung des Angebots, welches Sie erhalten werden.</p>
                </>}
                <div className={"safe-actions mt-1"}>
                    {backButtonVisible.indexOf(currentStep) >= 0 && <Button key="back" theme="secondary-button mr-1 mb-1" width={230}
                            submitting={submitting} onClick={e => {
                        e.preventDefault();
                        previousStep();
                    }}>zurück</Button>}
                    {forwardButtonVisible.indexOf(currentStep) >= 0 && <Button key="submit" theme="primary-button mb-1" width={230}
                            submitting={submitting}>Weiter</Button>}
                </div>

            </form>
            {/*needs to be outside form since it makes it own*/}
            {currentStep == 'Bestätigung' && <>
                <div className="guest-request-v2">
                    <SignOrder order={orderInfoTokenPair.info} isPublic={true} signed={nextStep}></SignOrder>
                </div>
            </>}
        </Layout>
    </>
}
